import React from "react";
import classes from "./SuccessModal.module.scss";
import boughtProductImg from "../../assets/cart/image-xx99-mark-two-headphones.jpg";
import { Link } from "react-router-dom";
const SuccessModal = () => {
  return (
    <section className={classes.successModal}>
      <div className={classes.modalBlock}>
        <div className={classes.modalBlockContent}>
          <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <circle fill="#D87D4A" cx="32" cy="32" r="32" />
              <path
                stroke="#FFF"
                stroke-width="4"
                d="m20.754 33.333 6.751 6.751 15.804-15.803"
              />
            </g>
          </svg>
          <p className={classes.thanks}>
            Thank you <br /> for your order
          </p>
          <p className={classes.confirmation}>
            You will receive an email confirmation shortly.{" "}
          </p>
          <section className={classes.product_summary}>
            <div className={classes.product}>
              <div className={classes.product_inner_content}>
                <section className={classes.upper_inner_content}>
                  <img
                    src={boughtProductImg}
                    alt=""
                    className={classes.bought_img}
                  />
                  <div className={classes.bought_product_info}>
                    <span className={classes.bought_prod}>XX99 MK II</span>{" "}
                    <span className={classes.amount_spent}>$2,999</span>
                  </div>
                  <span className={classes.quantity}>x1</span>
                </section>

                <p className={classes.otherItems}> and 2 other item(s) </p>
              </div>
            </div>
            <div className={classes.grand_total}>
              <p className={classes.grand_total_content}>
                {" "}
                <span className={classes.grand_total_text}>Grand total</span>
                <br />{" "}
                <span className={classes.grand_total_amount}>$5,526</span>
              </p>
            </div>
          </section>

          <Link to="/" className={classes.toHome}>
            Back to home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SuccessModal;
